import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteCarouselBanners = async (data: number[]) => {
	const url = "/homepage/admin/carouselbanner/delete/";

	const response = await cmsClient.delete(url, { data });

	return response.data;
};

const useDeleteCarouselBanners = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Banner(s) have been deleted" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["active-banners"]);
		queryClient.invalidateQueries(["banner-library"]);
	};

	const onError = (error: unknown) => {
		const message =
			axios.isAxiosError(error) && error.response?.status === 412
				? "This banner must be unpublished before it can be deleted"
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(deleteCarouselBanners, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useDeleteCarouselBanners;
